/**
 * 商品列唯一鍵（供表格 rowKey 等使用）
 * 有 productID 時用 productID_variantID，否則用 sku
 * @param {{ productID?: number|null, variantID?: number|null, sku?: string }} row
 * @returns {string}
 */
export const getProductRowKey = (row) =>
	row.productID != null ? `${row.productID}_${row.variantID ?? ""}` : row.sku ?? "";
